// Services must be imported to this file ONLY if
// they are used directly via the angular app (via `window.RWS.client.get('...')`)
//
// In most cases, services are already imported in rws components which use them.
// They do not need to be imported here.
import "../services/LearnosityDRService";
import "../services/AccessibilityService";
import "../services/CourseDashboardService";
import "../services/CalendarService";
import "../services/StorageService";
import "../services/JunctionChat";
import "../services/CoursePaymentsService";
import "../components/programs/CourseService";
import "../services/AnnouncementService";
import "../services/CurrentAnnouncementService";
import "../services/FirebaseService";
import "../services/SnapScrollService";
import "../services/InsightsDashboardService";
import "../components/jnct-file-uploader/FileUploaderLibraryService";
import "../components/jnct-file-uploader/FileUploaderEmbedService";
import "../services/ActivitySettingsV2Service";
import "../services/ThemeService";
import "../services/ContentsService";
import "../services/InsightsGradebookService";
import "../services/InstructorNotesService";
import "../components/plugin_components/PluginService";
import "LearnosityCQT/LearnosityCustomQuestionsService";
